export default __webpack_public_path__ + "images/79da81e666172bf40eef35604bed31ad.svg";